/**
* DevExpress HTML/JS Reporting (designer\internal\scripting\_eventArgsTypes.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventArgsTypes = {
    'EvaluateBinding': 'DevExpress.XtraReports.UI.BindingEventArgs',
    'AfterPrint': 'System.EventArgs',
    'BeforePrint': 'System.Drawing.Printing.PrintEventArgs',
    'PrintOnPage': 'DevExpress.XtraReports.UI.PrintOnPageEventArgs',
    'Draw': 'DevExpress.XtraReports.UI.DrawEventArgs',
    'HtmlItemCreated': 'DevExpress.XtraReports.UI.HtmlEventArgs',
    'LocationChanged': 'DevExpress.XtraReports.UI.ChangeEventArgs',
    'ParentChanged': 'DevExpress.XtraReports.UI.ChangeEventArgs',
    'PreviewClick': 'DevExpress.XtraReports.UI.PreviewMouseEventArgs',
    'PreviewDoubleClick': 'DevExpress.XtraReports.UI.PreviewMouseEventArgs',
    'PreviewMouseDown': 'DevExpress.XtraReports.UI.PreviewMouseEventArgs',
    'PreviewMouseMove': 'DevExpress.XtraReports.UI.PreviewMouseEventArgs',
    'PreviewMouseUp': 'DevExpress.XtraReports.UI.PreviewMouseEventArgs',
    'SizeChanged': 'DevExpress.XtraReports.UI.ChangeEventArgs',
    'TextChanged': 'System.EventArgs',
    'SummaryCalculated': 'DevExpress.XtraReports.UI.TextFormatEventArgs',
    'SummaryGetResult': 'DevExpress.XtraReports.UI.SummaryGetResultEventArgs',
    'SummaryReset': 'System.EventArgs',
    'SummaryRowChanged': 'System.EventArgs',
    'BandLevelChanged': 'System.EventArgs',
    'SortingSummaryGetResult': 'DevExpress.XtraReports.UI.GroupSortingSummaryGetResultEventArgs',
    'SortingSummaryReset': 'System.EventArgs',
    'SortingSummaryRowChanged': 'DevExpress.XtraReports.UI.GroupSortingSummaryRowChangedEventArgs',
    'DataSourceDemanded': 'System.EventArgs',
    'BandHeightChanged': 'DevExpress.XtraReports.UI.BandEventArgs',
    'DataSourceRowChanged': 'DevExpress.XtraReports.UI.DataSourceRowEventArgs',
    'FillEmptySpace': 'DevExpress.XtraReports.UI.BandEventArgs',
    'PrintProgress': 'DevExpress.XtraPrinting.PrintProgressEventArgs',
    'ParametersRequestBeforeShow': 'DevExpress.XtraReports.Parameters.ParametersRequestEventArgs',
    'ParametersRequestValueChanged': 'DevExpress.XtraReports.Parameters.ParametersRequestValueChangedEventArgs',
    'ParametersRequestSubmit': 'DevExpress.XtraReports.Parameters.ParametersRequestEventArgs',
    'GetValue': 'DevExpress.XtraReports.UI.GetValueEventArgs',
    'FieldValueDisplayText': 'DevExpress.XtraReports.UI.PivotGrid.PivotFieldDisplayTextEventArgs',
    'PrintCell': 'DevExpress.XtraReports.UI.PivotGrid.CustomExportCellEventArgs',
    'PrintFieldValue': 'DevExpress.XtraReports.UI.PivotGrid.CustomExportFieldValueEventArgs',
    'PrintHeader': 'DevExpress.XtraReports.UI.PivotGrid.CustomExportHeaderEventArgs',
    'CustomSummary': 'DevExpress.XtraReports.UI.PivotGrid.PivotGridCustomSummaryEventArgs',
    'CustomGroupInterval': 'DevExpress.XtraReports.UI.PivotGrid.PivotCustomGroupIntervalEventArgs',
    'CustomChartDataSourceData': 'DevExpress.XtraReports.UI.PivotGrid.PivotCustomChartDataSourceDataEventArgs',
    'CustomChartDataSourceRows': 'DevExpress.XtraReports.UI.PivotGrid.PivotCustomChartDataSourceRowsEventArgs',
    'CustomCellDisplayText': 'DevExpress.XtraReports.UI.PivotGrid.PivotCellDisplayTextEventArgs',
    'CustomCellValue': 'DevExpress.XtraReports.UI.PivotGrid.PivotCellValueEventArgs',
    'CustomColumnWidth': 'DevExpress.XtraReports.UI.PivotGrid.PivotCustomColumnWidthEventArgs',
    'CustomFieldSort': 'DevExpress.XtraReports.UI.PivotGrid.PivotGridCustomFieldSortEventArgs',
    'CustomServerModeSort': 'DevExpress.XtraReports.UI.PivotGrid.PivotGridCustomServerModeSortEventArgs',
    'CustomFieldValueCells': 'DevExpress.XtraReports.UI.PivotGrid.PivotCustomFieldValueCellsEventArgs',
    'CustomRowHeight': 'DevExpress.XtraReports.UI.PivotGrid.PivotCustomRowHeightEventArgs',
    'CustomUnboundFieldData': 'DevExpress.XtraReports.UI.PivotGrid.CustomFieldDataEventArgs',
    'PrefilterCriteriaChanged': 'System.EventArgs',
    'CustomDrawSeries': 'DevExpress.XtraCharts.CustomDrawSeriesEventArgs',
    'CustomDrawSeriesPoint': 'DevExpress.XtraCharts.CustomDrawSeriesPointEventArgs',
    'CustomDrawCrosshair': 'DevExpress.XtraCharts.CustomDrawCrosshairEventArgs',
    'CustomDrawAxisLabel': 'DevExpress.XtraCharts.CustomDrawAxisLabelEventArgs',
    'CustomPaint': 'DevExpress.XtraCharts.CustomPaintEventArgs',
    'BoundDataChanged': 'System.EventArgs',
    'PieSeriesPointExploded': 'DevExpress.XtraCharts.PieSeriesPointExplodedEventArgs',
    'AxisScaleChanged': 'DevExpress.XtraCharts.AxisScaleChangedEventArgs',
    'AxisWholeRangeChanged': 'DevExpress.XtraCharts.AxisRangeChangedEventArgs',
    'AxisVisualRangeChanged': 'DevExpress.XtraCharts.AxisRangeChangedEventArgs',
    'SmallChartTextShowing': 'System.EventArgs'
};
